module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/library/modules/_library.js
// module id = 54
// module chunks = 1